export default __webpack_public_path__ + "static/media/04AW3SEP66.d8af4db8.jpg";